import type { LeadPackagePrice } from './agent';

const LEGACY_SIZES = [30, 50, 100, 200, 500];
const DISCOUNTS: Record<number, number> = { 30: 0, 50: 5, 100: 10, 200: 15, 500: 20 };
const LEADS_PER_PERCENT: Record<number, number> = { 30: 4, 50: 10, 100: 20, 200: 60, 500: 60 };

const volumeDiscount = (size: number) => {
    const threshold = [...LEGACY_SIZES].reverse().find((value) => size >= value) || 30;
    return DISCOUNTS[threshold] + Math.floor((size - threshold) / LEADS_PER_PERCENT[threshold]);
};

// The previous API lists five sizes. The new API returns every 10-lead step.
// Expand only the recognizable legacy response, using the same integer-cent
// calculation as the server; keep an explicit server price whenever present.
export function completePackagePrices(prices: LeadPackagePrice[]): LeadPackagePrice[] {
    const active = prices.filter((price) => price.is_active);
    if (active.length !== LEGACY_SIZES.length ||
        !LEGACY_SIZES.every((size) => active.some((price) => price.package_size === size)) ||
        !active.every((price) => price.one_time_price_per_lead && price.monthly_price_per_lead)) {
        return prices;
    }
    const first = active.find((price) => price.package_size === 30)!;
    const baseCents = Math.round(Number(first.one_time_price_per_lead) * 100);
    if (!Number.isSafeInteger(baseCents) || baseCents <= 0) return prices;
    const bySize = new Map(active.map((price) => [price.package_size, price]));
    return Array.from({ length: 98 }, (_, index) => {
        const size = 30 + index * 10;
        const existing = bySize.get(size);
        if (existing) return existing;
        const discount = volumeDiscount(size);
        const onceCents = Math.round(baseCents * (100 - discount) / 100);
        const monthlyCents = Math.round(onceCents * 90 / 100);
        return {
            ...first,
            id: -size,
            package_size: size,
            price_per_lead: (monthlyCents / 100).toFixed(2),
            monthly_price_per_lead: (monthlyCents / 100).toFixed(2),
            one_time_price_per_lead: (onceCents / 100).toFixed(2),
            discount_percent: discount,
        };
    });
}
